"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {},
        wrapper: {},
        selector: {
            border: "1px solid " + theme.palette.neutralTertiary,
            minHeight: 32,
            selectors: {
                "&:focus": {
                    border: "1px solid " + theme.palette.themePrimary
                },
                "&:hover": {
                    border: "1px solid " + theme.palette.neutralSecondary
                }
            }
        },
        selectorAction: {
            background: "transparent",
            outline: "none",
            textAlign: "left",
            padding: "4px 12px",
            border: "none",
            minHeight: 32
        }
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
